export const deleteCompaniesApiUrls = {
	deleteCompany: 'company/:companyId',
};
